import { Box, ButtonBase, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useAuth } from "../../auth/AuthContext";
import LoadingPage from "../../Loader";

const News = () => {
  const [leaves, setLeaves] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { getData } = useAuth();

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        setError(null);

        const leavesResponse = await getData("proccess.php", "news_V2");
        if (leavesResponse.success && Array.isArray(leavesResponse.data)) {
          const currentDate = new Date(); // Current date
          const fiveMonthsAgo = new Date(currentDate);
          fiveMonthsAgo.setMonth(currentDate.getMonth() - 5); // Subtract 5 months

          // Filter news to only include featured items within the last 5 months
          const filteredLeaves = leavesResponse.data.filter((leave) => {
            const createdDate = new Date(leave.dateCreated);
            return leave.isFeafured === 'yes' && createdDate >= fiveMonthsAgo;
          });

          // Sort by newsOrder (ascending) and then get top 5 based on newsDate
          const sortedLeaves = filteredLeaves
            .sort((a, b) => {
              // Primary sort by newsOrder
              if (a.newsOrder !== b.newsOrder) {
                return (a.newsOrder || 999) - (b.newsOrder || 999);
              }
              // Secondary sort by newsDate (newest first)
              return new Date(b.newsDate) - new Date(a.newsDate);
            })
            .slice(0, 50); // Get only top 50

          setLeaves(sortedLeaves);
        } else {
          console.error("Leaves response error:", leavesResponse.message || "No data");
          setLeaves([]);
        }
      } catch (err) {
        console.error("Fetch error:", err);
        setError("Failed to load news. Please try again later.");
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [getData]);

  const handleNewsClick = (leave) => {
    if (leave.externalLink) {
      window.open(leave.externalLink, '_blank', 'noopener noreferrer');
    } else {
      window.location.href = `/media/news?uuid=${leave.id}&uucat=news`;
    }
  };

  if (loading) {
    return <LoadingPage />;
  }

  if (error) {
    return (
      <Box minHeight="100vh" display="flex" justifyContent="center" alignItems="center">
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  return (
    <Box minHeight="auto" width="100%" bgcolor="transparent" paddingBottom={'1rem'}>
      <Typography variant="h4" color="black" align="center" sx={{ padding: 2 }}>
        Latest News
      </Typography>
      {leaves.length === 0 ? (
        <Typography color="black" align="center" sx={{ padding: 2 }}>
          No featured news available at the moment.
        </Typography>
      ) : (
        leaves.map((leave, index) => (
          <Box
            key={index}
            sx={{ padding: 2, backgroundColor: "white", margin: 2, borderRadius: 1 }}
            boxShadow={2}
          >
            <Box>
              <Typography variant="h6" color="#22aa38ff" fontWeight={700}>
                {leave.title || "Untitled"}
              </Typography>
              <Typography variant="body1" margin={'.5rem 0'}>
                {leave.description && leave.description.length > 200 
                ? leave.description.substring(0, 200) + "..." 
                : leave.description || "No content available"}
              </Typography>
              
              <ButtonBase
                onClick={() => handleNewsClick(leave)}
                sx={{
                  padding: ".5rem 1rem",
                  margin: ".2rem 0",
                  color: "#32a059",
                  textDecoration: "underline",
                  cursor: 'pointer',
                  '&:hover': {
                    color: "#256f42",
                  }
                }}
              >
                {leave.description && leave.description.length > 200 ? "Read More" : "View"}
              </ButtonBase>
            </Box>
            
            {leave.image && (
              <Box
                sx={{
                  width: '100%',
                  height: 'auto',
                  borderRadius: '10px',
                  overflow: 'hidden',
                  marginTop: 2
                }}
              >
                <img
                  src={`https://mindsinaction.com.na/assets/media/pictures/${leave.image}`}
                  alt={leave.title}
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              </Box>
            )}
            
            {/* <Typography variant="body1" color="gray" sx={{ marginTop: 1 }}>
              {leave.newsDate || leave.dateCreated || " "}
            </Typography> */}
          </Box>
        ))
      )}
    </Box>
  );
};

export default News;